import Settings from '../../pages/Settings';

import { uuid } from '../../utils/helper';

export default [
  {
    name: 'Settings',
    link: '/settings',
    secondaryLinks: [
      '/settings/providers',
      '/settings/modules',
      '/settings/bonuses',
      '/settings/integrations',
      '/settings/payments',
      '/settings/notifications',
      '/settings/signup-form',
      '/settings/ticket-form',
    ],
    id: uuid(),
    component: Settings,
    react: true,
  },
];
